import React from "react";
import { AbsoluteFill, interpolate, useCurrentFrame } from "remotion";
import { useEnvelope, PlayIcon, BellIcon, bellRing, YT_RED, BTN_SHADOW, TEXT_SHADOW } from "./CTAKit";

// CTA #5 — wide lower-third: channel identity + "SUBSCRIBE for more factory secrets".
export const CTALowerThird: React.FC<{ channel?: string; tagline?: string; bottom?: number }> = ({
  channel = "FACTORY PROCESS DECODER",
  tagline = "SUBSCRIBE for more factory secrets",
  bottom = 70,
}) => {
  const { o, fps } = useEnvelope();
  const frame = useCurrentFrame();
  // bar wipes in from the left
  const wipe = interpolate(frame, [0, Math.round(fps * 0.5)], [0, 1], { extrapolateRight: "clamp" });
  const pulse = 1 + 0.04 * Math.sin(frame * 0.25);

  return (
    <AbsoluteFill style={{ justifyContent: "flex-end", alignItems: "center", paddingBottom: bottom }}>
      <div
        style={{
          opacity: o,
          display: "flex", alignItems: "center", gap: 18,
          background: "rgba(12,12,14,0.82)",
          borderLeft: `6px solid ${YT_RED}`,
          padding: "16px 22px",
          borderRadius: 14,
          boxShadow: BTN_SHADOW,
          transform: `scaleX(${wipe})`,
          transformOrigin: "left center",
        }}
      >
        <div style={{ width: 52, height: 52, borderRadius: 12, background: YT_RED, display: "flex", alignItems: "center", justifyContent: "center", flexShrink: 0 }}>
          <BellIcon size={30} ring={bellRing(frame, fps, 0.6)} />
        </div>
        <div style={{ display: "flex", flexDirection: "column", gap: 2, transform: `scaleX(${1 / Math.max(wipe, 0.01)})`, transformOrigin: "left center", opacity: wipe }}>
          <div style={{ color: "#fff", fontFamily: "Inter, Arial, sans-serif", fontWeight: 900, fontSize: 26, letterSpacing: 1.5, textShadow: TEXT_SHADOW, whiteSpace: "nowrap" }}>
            {channel}
          </div>
          <div style={{ color: "rgba(255,255,255,0.82)", fontFamily: "Inter, Arial, sans-serif", fontWeight: 600, fontSize: 16, letterSpacing: 0.5, whiteSpace: "nowrap" }}>
            {tagline}
          </div>
        </div>
        <div style={{ display: "flex", alignItems: "center", gap: 8, background: YT_RED, color: "#fff", fontFamily: "Inter, Arial, sans-serif", fontWeight: 900, fontSize: 20, letterSpacing: 1, padding: "10px 18px", borderRadius: 999, marginLeft: 6, transform: `scale(${pulse})`, whiteSpace: "nowrap" }}>
          <PlayIcon size={20} /> SUBSCRIBE
        </div>
      </div>
    </AbsoluteFill>
  );
};

;
    var _remotion_globalVariableA;
    var _remotion_globalVariableB;
    // Legacy CSS implementations will `eval` browser code in a Node.js context
    // to extract CSS. For backwards compatibility, we need to check we're in a
    // browser context before continuing.
    if (typeof self !== 'undefined' &&
        // AMP / No-JS mode does not inject these helpers:
        '$RefreshHelpers$' in self) {
        const currentExports = __webpack_module__.exports;
        const prevExports = (_remotion_globalVariableB = (_remotion_globalVariableA = __webpack_module__.hot.data) === null || _remotion_globalVariableA === void 0 ? void 0 : _remotion_globalVariableA.prevExports) !== null && _remotion_globalVariableB !== void 0 ? _remotion_globalVariableB : null;
        // This cannot happen in MainTemplate because the exports mismatch between
        // templating and execution.
        self.$RefreshHelpers$.registerExportsForReactRefresh(currentExports, __webpack_module__.id);
        // A module can be accepted automatically based on its exports, e.g. when
        // it is a Refresh Boundary.
        if (self.$RefreshHelpers$.isReactRefreshBoundary(currentExports)) {
            // Save the previous exports on update so we can compare the boundary
            // signatures.
            __webpack_module__.hot.dispose((data) => {
                data.prevExports = currentExports;
            });
            // Unconditionally accept an update to this module, we'll check if it's
            // still a Refresh Boundary later.
            __webpack_module__.hot.accept();
            // This field is set when the previous version of this module was a
            // Refresh Boundary, letting us know we need to check for invalidation or
            // enqueue an update.
            if (prevExports !== null) {
                // A boundary can become ineligible if its exports are incompatible
                // with the previous exports.
                //
                // For example, if you add/remove/change exports, we'll want to
                // re-execute the importing modules, and force those components to
                // re-render. Similarly, if you convert a class component to a
                // function, we want to invalidate the boundary.
                if (self.$RefreshHelpers$.shouldInvalidateReactRefreshBoundary(prevExports, currentExports)) {
                    __webpack_module__.hot.invalidate();
                }
                else {
                    self.$RefreshHelpers$.scheduleUpdate();
                }
            }
        }
        else {
            // Since we just executed the code for the module, it's possible that the
            // new exports made it ineligible for being a boundary.
            // We only care about the case when we were _previously_ a boundary,
            // because we already accepted this update (accidental side effect).
            const isNoLongerABoundary = prevExports !== null;
            if (isNoLongerABoundary) {
                __webpack_module__.hot.invalidate();
            }
        }
    }
